<!--
트래킹검수 > 트래킹내역 컴포넌트
------------------------------------
-->
<template>
    <div class="" >
        <!-- has not selected 경고문구 -->
        <div class="uk-text-large uk-padding uk-text-center" v-show="hasNotSelected">
            <span class="uk-text-large3 uk-text-danger">
                <i class="material-icons uk-text-middle" style="font-size: 60px">
                    error_outline
                </i>
                완전히 일치하는 자료가 없습니다
            </span><br />
            아래의 비슷한 트래킹번호를 확인하세요
        </div>

        <div class="uk-padding">
            <div class="uk-text-large">
                <i class="material-icons uk-text-bottom" style="font-size: 32px">
                    list
                </i>
                비슷한 트래킹번호
                <span class="uk-text-muted">(검수할 트래킹을 선택하세요)</span>
            </div>

            <div class="uk-card uk-card-default uk-margin-bottom">

                <table class="tracking-list">
                    <colgroup>
                        <col style="width: 300px">
                        <col style="width: 200px">
                        <col>
                        <col>
                        <col>
                    </colgroup>
                    <thead>
                    <tr>
                        <th>
                            <i class="material-icons">check</i>
                            검수
                        </th>
                        <th title="트래킹 박스 내 총 상품수량">
                            <i class="material-icons">star_border</i>
                            상품수량
                        </th>
                        <th class="tracking">
                            <i class="material-icons">local_shipping</i>
                            트래킹번호
                        </th>

                        <th>
                            <i class="material-icons">mail</i>
                            사서함
                        </th>

                        <th>
                            <i class="material-icons">account_box</i>
                            회원사
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(tracking, index) in trackings"
                        :key="index"
                    >
                        <td>
                            <button
                                class="uk-button uk-button-primary uk-button-large2"
                                @click="checkTracking(tracking)"
                            >
                                <i class="material-icons">check</i>
                                검수
                            </button>
                        </td>
                        <td>
                            {{ tracking.total_prod_amount }}
                        </td>
                        <td class="tracking">
                            <a @click="checkTracking(tracking)">
                                {{ tracking.tracking_no }}
                            </a>
                        </td>
                        <td>
                            {{ tracking.user_mailbox }}
                        </td>
                        <td>
                            {{ tracking.user_nick }}
                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>

            <!-- 무자료버튼 -->
            <div class="uk-text-large uk-margin-large-top uk-text-muted uk-text-center">
                <i class="material-icons">
                    error_outline
                </i>
                일치하는 자료가 없을 경우,
                무자료 처리하세요
            </div>
            <div class="uk-text-center">
                <button
                    class="uk-button uk-button-white uk-button-large2"
                    @click="$parent.showNodata"
                >
                    <i class="material-icons">edit</i>
                    무자료 등록하기
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * (array) 조회된 트래킹 내역
             */
            trackings: {
                type: Array,
                default: [],
            },

            /**
             * 조회된 트래킹 내역은 있는데, 현재 선택된 트래킹이 없음
             */
            hasNotSelected: {
                type: Boolean,
                default: false,
            },

        },
        data: function () {
            return {

            };
        },
        computed: {

        },

        methods: {
            /**
             * 선택한 트래킹을 검수함
             * @param tracking 선택한 트래킹정보
             *
             */
            checkTracking: function (tracking) {
                this.$parent.checkTracking(tracking);
            } ,
        },
    }
</script>

<style lang="scss" scoped>
    .tracking-list {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        .material-icons {
            vertical-align: middle;
            font-size: 32px;
        }

        th, td {
            font-size: 1.5rem;
            text-align: center;
            padding: 10px;
            font-weight: normal;

            &.tracking {
                text-align: left;

            }

            border: 1px solid #cfcfcf;

        }


        td.tracking {
            font-size: 2rem;
            a {
                color: #000;
                text-decoration: none;
            }
        }

        tr:hover td {
            background-color: #e6f5ff;
        }

    }
</style>